import React from 'react';
import { Card } from '@/components/ui';
import type { ConstructionProgressLog } from '../types/construction-progress.types';

interface Props {
  log: ConstructionProgressLog;
}

export const ProgressResourceCard: React.FC<Props> = ({ log }) => {
  return (
    <Card className="p-6 bg-slate-900 text-white">
      <h4 className="font-bold mb-4 flex items-center gap-2 text-os-primary">
        <i className="ri-user-settings-line" />
        Nguồn lực tiêu thụ
      </h4>
      <div className="space-y-4">
        <div className="p-3 bg-slate-800 rounded-2xl border border-slate-700 flex justify-between items-center">
          <div>
            <p className="text-[10px] text-slate-400 font-bold ">Nhân công</p>
            <p className="text-lg font-bold text-slate-200">{log.man_hours} <span className="text-xs font-normal">h</span></p>
          </div>
          <i className="ri-group-line text-2xl text-slate-600" />
        </div>
        <div className="p-3 bg-slate-800 rounded-2xl border border-slate-700 flex justify-between items-center">
          <div>
            <p className="text-[10px] text-slate-400 font-bold ">Thiết bị/Máy</p>
            <p className="text-lg font-bold text-slate-200">{log.equipment_hours} <span className="text-xs font-normal">h</span></p>
          </div>
          <i className="ri-truck-line text-2xl text-slate-600" />
        </div>
      </div>
    </Card>
  );
};
